import logo from '../../assets/arrive-logotype-white-RGB.svg';

const ArriveLogo = () => (
    <img src={logo} alt="Arrive" style={{ height: 60, width: 'auto' }} />
);
export default ArriveLogo;
